/**
 * Geometry-related constants
 * Replaces magic strings and numbers in drag/resize hooks
 *
 * @module constants/geometry
 */

// ===== MOUSE BUTTONS =====

/** Left mouse button (primary button) */
export const MOUSE_BUTTON_LEFT = 0;

/** Middle mouse button (wheel button) */
export const MOUSE_BUTTON_MIDDLE = 1;

/** Right mouse button (context menu button) */
export const MOUSE_BUTTON_RIGHT = 2;

// ===== CURSORS =====

/** Default cursor (empty string resets to default) */
export const CURSOR_DEFAULT = '';

/** Grabbing cursor (while dragging) */
export const CURSOR_GRABBING = 'grabbing';

/** Grab cursor (hoverable draggable elements, before drag starts) */
export const CURSOR_GRAB = 'grab';

/** Pointer cursor (hoverable elements) */
export const CURSOR_POINTER = 'pointer';

/** Move cursor (movable elements) */
export const CURSOR_MOVE = 'move';

// ===== MAPLIBRE SOURCE PREFIXES =====

/** Prefix for line geometry MapLibre sources */
export const LINE_SOURCE_PREFIX = 'line-source-';

/** Prefix for shape geometry MapLibre sources */
export const SHAPE_SOURCE_PREFIX = 'shape-source-';

/** Prefix for marker geometry MapLibre sources */
export const MARKER_SOURCE_PREFIX = 'marker-source-';

// ===== MAPLIBRE LAYER PREFIXES =====

/** Prefix for line hitbox (interactive) layers */
export const LINE_HITBOX_PREFIX = 'line-hitbox-';

/** Prefix for shape hitbox (interactive) layers */
export const SHAPE_HITBOX_PREFIX = 'shape-hitbox-';

// ===== DOM SELECTORS =====

/** Selector for line point handles (drag individual vertices) */
export const POINT_HANDLE_SELECTOR = '[data-point-index]';

/** Selector for shape resize handles (drag corners/edges) */
export const RESIZE_HANDLE_SELECTOR = '[data-resize-handle-index]';

// ===== SPECIAL TASK IDs =====

/** Special task ID for preview geometries (not yet saved) */
export const PREVIEW_TASK_ID = 'preview';

// ===== GEOMETRY VALIDATION =====

/** Minimum length for geometry names (characters) */
export const GEOMETRY_NAME_MIN_LENGTH = 1;

/** Maximum length for geometry names (characters) */
export const GEOMETRY_NAME_MAX_LENGTH = 100;

/** Minimum unique points required for a valid line geometry */
export const MIN_UNIQUE_POINTS_FOR_LINE = 2;

/** Minimum points required before allowing line deletion (used in keyboard shortcuts) */
export const MIN_POINTS_BEFORE_DELETE_LINE = 2;
